query isEmailAddressUsed($emailAddress: String!) {
    isEmailAddressUsed(emailAddress: $emailAddress)
}